import { useEffect } from 'react';

interface SEOMeta {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
}

export function useSEO(meta: SEOMeta) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = meta.title;

    const setMetaTag = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    setMetaTag('description', meta.description);
    if (meta.keywords) setMetaTag('keywords', meta.keywords);

    if (meta.canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', meta.canonicalUrl);
    }

    if (meta.ogTitle) setMetaTag('og:title', meta.ogTitle, true);
    if (meta.ogDescription) setMetaTag('og:description', meta.ogDescription, true);
    if (meta.ogImage) setMetaTag('og:image', meta.ogImage, true);
    if (meta.ogType) setMetaTag('og:type', meta.ogType, true);

    if (meta.twitterCard) {
      setMetaTag('twitter:card', meta.twitterCard);
      if (meta.ogTitle) setMetaTag('twitter:title', meta.ogTitle);
      if (meta.ogDescription) setMetaTag('twitter:description', meta.ogDescription);
    }

    return () => {
      document.title = previousTitle;
    };
  }, [meta]);
}